<template>
	<popup-layout>
		<template slot="page-header-right">
		</template>

		<template slot="page-content">
			<slot name="page-content">
				<loader v-if="!receivedTokenRequest"></loader>
				<div v-if="receivedTokenRequest" id='login-content'>
					<button type="button" class="btn btn-primary" @click="login"><i class="fa fa-fw fa-lock"></i> Sign in / Sign up</button>
				</div>
			</slot>
		</template>
	</popup-layout>
</template>

<script>
const logger = require("@/utils/logger");
const auth = require("@/utils/auth");
const onestoreutils = require("onestore-utils");
import appAuthorization from "@/utils/app-authorization";
import router from "@/router";

export default {
  data() {
    return {
      redirectTo: "",
      receivedTokenRequest: false
    };
  },
  methods: {
    login() {
      return auth.login(this.redirectTo);
    },
    debug() {
      return debug();
    }
  },
  mounted() {
    window._onestore_mode = "popup";

    var qs = onestoreutils.parsehashBangQueryStringParams();
    
    if (qs.mode == "auto") {
      var _this = this;
      appAuthorization.listenToCrossWindowsPostMessages(function() {
        _this.receivedTokenRequest = true;
      });
      this.redirectTo = "/app-auto-auth";
    } else if (qs.mode == "copy") {
      this.redirectTo = "/app-create-token";
    } else {
      this.redirectTo = "/hu?";
    }
    logger.log("Will redirect to " + this.redirectTo);
  }
};
</script>


<style scoped>
#login-content {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/AppLogin.vue